import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import FadeUp from "./FadeUp";
import QuoteForm from "./QuoteForm";
import CTASection from "./CTASection";

export const ServicePage = ({
  service,
  tagline,
  intro,
  tasksTitle = "What's included",
  tasks = [],
  quoteHeading,
  quoteType = "quote",
  afterContent = null,
}) => {
  const isBook = service.ctaType === "book";

  return (
    <div data-testid={`service-page-${service.slug}`}>
      {/* Hero */}
      <section className="section-pad">
        <div className="container-hh grid items-center gap-12 lg:grid-cols-2">
          <FadeUp>
            <p className="eyebrow">Service</p>
            <h1 className="mt-3 text-4xl md:text-5xl lg:text-6xl">
              {service.title}
            </h1>
            <p className="mt-4 font-serif text-2xl text-teal">{tagline}</p>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-bodytext">
              {intro}
            </p>
            <div className="mt-7 inline-flex flex-col gap-1 rounded-[12px] bg-seafoam px-6 py-4">
              <span className="font-serif text-3xl text-navy">
                {service.price}
              </span>
              <span className="text-sm text-bodytext/80">{service.priceNote}</span>
            </div>
            <div className="mt-8">
              {isBook ? (
                <Link to="/book" data-testid="service-hero-cta" className="btn-teal">
                  {service.cta}
                </Link>
              ) : (
                <a href="#quote" data-testid="service-hero-cta" className="btn-teal">
                  {service.cta}
                </a>
              )}
            </div>
          </FadeUp>

          <FadeUp delay={0.1}>
            <div className="overflow-hidden rounded-[12px] shadow-cozy-lg">
              <img
                src={service.image}
                alt={service.title}
                loading="lazy"
                className="h-full max-h-[520px] w-full object-cover"
              />
            </div>
          </FadeUp>
        </div>
      </section>

      {/* Task list */}
      {tasks.length > 0 && (
        <section className="section-pad bg-seafoam">
          <div className="container-hh">
            <FadeUp>
              <h2 className="text-3xl md:text-4xl">{tasksTitle}</h2>
            </FadeUp>
            <div className="mt-10 grid gap-x-8 gap-y-4 sm:grid-cols-2 lg:grid-cols-3">
              {tasks.map((t, i) => (
                <FadeUp key={t} delay={Math.min(i * 0.03, 0.3)}>
                  <div className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-teal/15">
                      <Check className="h-4 w-4 text-teal" />
                    </span>
                    <span className="text-bodytext">{t}</span>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>
        </section>
      )}

      {afterContent}

      {/* CTA / quote */}
      {isBook ? (
        <CTASection buttonLabel={service.cta} />
      ) : (
        <section id="quote" className="section-pad">
          <div className="container-hh grid items-start gap-12 lg:grid-cols-2">
            <FadeUp>
              <p className="eyebrow">Let's talk</p>
              <h2 className="mt-3 text-3xl md:text-4xl">
                Tell us about your home
              </h2>
              <p className="mt-4 max-w-md text-lg leading-relaxed text-bodytext">
                Share a few details and we'll put together a plan and a price.
                Sarah personally follows up within 24 hours.
              </p>
            </FadeUp>
            <FadeUp delay={0.1}>
              <QuoteForm
                service={service.title}
                heading={quoteHeading || service.cta}
                submitLabel={service.cta}
                type={quoteType}
              />
            </FadeUp>
          </div>
        </section>
      )}
    </div>
  );
};

export default ServicePage;
